module.exports = __webpack_public_path__ + "img/share-copy-link.4dd6361f.svg";